import React from 'react';

import { PHRSuccessCheckmark as SuccessCheckmark } from '@palmhr/palmhr-ui-lib';
import cx from 'classnames';

import styles from './TranslationsTableRow.module.scss';
import TranslationsApi from '../api/TranslationsApi';
import TableDataCell from '../components/table/TableDataCell';
import useActionState from '../hooks/useActionState';

const TranslationsTableRow = ({ item, onApproved, setShowDeleteModal, setShowEditModal, selectRow }) => {
  const approveAction = useActionState();

  const handleApprove = async () => {
    await approveAction.execute(TranslationsApi.approveTranslation(item.id), {
      successMessage: 'Translation approved successfully',
      errorMessage: 'Failed to approve translation',
      onSuccess: () => {
        if (onApproved) {
          onApproved();
        }
      },
    });
  };

  return (
    <>
      <tr key={item.id} className={styles.tr}>
        <TableDataCell>
          <div className='text-truncate'>{item.translationKey}</div>
        </TableDataCell>
        <TableDataCell>{item.english}</TableDataCell>
        <TableDataCell className={cx(styles.arabic, 'pe-0 ps-3 text-right')}>{item.arabic}</TableDataCell>
        <TableDataCell>
          <div className='d-flex justify-content-end'>
            {item.review && (
              <button
                type='button'
                title='Approve'
                onClick={handleApprove}
                className='btn btn-light'
                disabled={approveAction.isLoading}
              >
                <i className={approveAction.isLoading ? 'icon-loading icon-spin' : 'icon-check-mark'} />
              </button>
            )}
            <button
              type='button'
              onClick={() => {
                selectRow(item);
                setShowEditModal(true);
              }}
              title='Edit'
              className='btn btn-light ms-1'
              disabled={approveAction.isLoading}
            >
              <i className='icon-pencil-create' />
            </button>
            <button
              type='button'
              onClick={() => {
                selectRow(item);
                setShowDeleteModal(true);
              }}
              title='Delete'
              className='btn btn-light ms-1'
              disabled={approveAction.isLoading}
            >
              <i className='icon-trash' />
            </button>
          </div>
        </TableDataCell>
      </tr>
      {approveAction.notification && (
        <SuccessCheckmark
          notification={{ show: approveAction.notification.show }}
          icon={approveAction.notification.success ? 'icon-success' : 'icon-error'}
          hideCheckmark={false}
          successString={approveAction.notification.message}
        />
      )}
    </>
  );
};

export default TranslationsTableRow;
